import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FullName } from '@portal/models/fullName';
import { ReportTemplateResponse } from '@portal/models/reportTemplateResponse';
import LangEnum = ReportTemplateResponse.LangEnum;

@Pipe({
  name: 'portalFullNamePipe',
  pure: true,
  standalone: false,
})
export class PortalFullNamePipe implements PipeTransform {
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(private readonly translateService: TranslateService) {}

  transform(value?: FullName, wrongValue?: string): string | null {
    if (!value) {
      return wrongValue || '';
    }

    return this.getFullName(value);
  }

  private getFullName(value?: FullName): string {
    switch (this.translateService.currentLang.toUpperCase() as LangEnum) {
      case 'RU': {
        return ` ${value.lastName ? value.lastName + ' ' : ''}
        ${value.firstName ? value.firstName + ' ' : ''}
        ${value.middleName ? value.middleName : ''}`;
      }

      default: {
        return `${value.firstName ? value.firstName + ' ' : ''}
        ${value.lastName ? value.lastName + ' ' : ''}
        ${value.middleName ? value.middleName : ''}`;
      }
    }
  }
}
